"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Poll = void 0;
const classes_1 = require("../classes");
class Poll {
    constructor({ id, name, question, answers, closed, owner_id, created_at, updated_at, user_answer, position } = {
        id: '',
        name: '',
        question: '',
        answers: [],
        closed: false,
        owner_id: 0,
        created_at: null,
        updated_at: null,
        user_answer: null,
        position: 0,
    }) {
        this.id = id;
        this.name = name;
        this.question = question;
        this.answers = answers.map((answer) => new classes_1.PollAnswer(answer));
        this.closed = closed;
        this.owner_id = owner_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.user_answer = user_answer;
        this.position = position;
    }
    toObject() {
        return {
            id: this.id,
            name: this.name,
            question: this.question,
            answers: this.answers.map((answer) => answer.toObject()),
            closed: this.closed,
        };
    }
    updateWith({ name, question, answers, closed, position, }) {
        if (typeof name !== 'undefined') {
            this.name = name;
        }
        if (typeof question !== 'undefined') {
            this.question = question;
        }
        if (typeof closed !== 'undefined') {
            this.closed = closed;
        }
        if (typeof position !== 'undefined') {
            this.position = position;
        }
        if (typeof answers !== 'undefined') {
            for (const answer of answers) {
                const currentAnswer = this.answers.filter((a) => a.id === answer.id);
                if (currentAnswer && currentAnswer[0]) {
                    answer.votes = currentAnswer[0].votes;
                }
            }
            this.answers = answers;
        }
    }
    get isAnswered() {
        return !!this.user_answer;
    }
}
exports.Poll = Poll;
//# sourceMappingURL=poll.js.map